import React, { useEffect, useState } from 'react';
import { createLayoutInstance } from '../../../Models/Layout';
import { toast } from 'react-toastify';
import './CTAPrimaryButton.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
const CTAPrimaryButton = (props) => {
    const [layoutInstance, setLayoutInstance] = useState(createLayoutInstance());
    const [currentData, setCurrentData] = useState(layoutInstance.getData());
    
    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        try {
            await layoutInstance.load();
            setCurrentData(layoutInstance.getData());
        } catch (error) {
            console.error(error);
            toast.error("Failed to load layout data");
        }
    };
    

    return (
        <button 
            className={`CTAButton col CTAPrimaryButton ${props.className}`} 
            onClick={props.onClick} 
            type={props.type} 
            disabled={props.disabled}   
        >
            {props.text}
            {props.icon && <FontAwesomeIcon icon={props.icon} className="ms-2 me-2" />}
            {props.navIcon && <i className={`fa-solid fa-${props.navIcon}  me-2 ms-2`} />}
        </button>
    );
};

export default CTAPrimaryButton;